import React from 'react';
import TitleDesc from './TitleDesc';

function EnvironmentalImpact(props) {
  return (
    <div className="my-bip-container env-impact-container">
      <div className="bip-top-strip">
        <div className="bip-icon-top back-arrow" onClick={() => props.setSelectedItem(null)}>
          <img style={{ marginLeft: '2%' }} src="/images/back_arrow_bip.png" alt="back_arrow_bip" />
        </div>

        <div>
          <div className="font13 center-text">
            <span>
              {props.t('PROFILE.ENV_IMPACT.NORMAL')}
              <span className="bold-text bip-top-strip-heading">
                {props.t('PROFILE.ENV_IMPACT.BOLD')}
              </span>
            </span>
          </div>
          <div className="font11 center-text bip-top-strip-sub-heading">
            <span>{props.t('PROFILE.ENVIRONMENTAL_IMPACT')}</span>
          </div>
        </div>
        <div></div>
      </div>

      <div className="bip-rows-container-main">
        <div className="env-top-strip kupos-card">
          <div className="env-top-strip-icon-container">
            <img
              className="env-top-strip-icon"
              src="/images/circular/enfironment.png"
              alt="enfironment"
            />
          </div>
          {props.titleDescItems.map((val, key) => (
            <TitleDesc val={val} key={key} envData={props.envData} t={props.t} />
          ))}
        </div>
      </div>
    </div>
  );
}

export default EnvironmentalImpact;



// WEBPACK FOOTER //
// ./src/features/my-account/MainTabsBodyMyAccount/components/EnvironmentalImpact.js